import { atom } from 'jotai';

import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

const filtersListAtom = atom<Filter[]>([]);

export { filtersListAtom };
